<template>
  <div id="AdultSeat">
    <div class="card">
      <div class="card-title">请输入成人座椅设备编号</div>
      <el-form
        :rules="rules"
        ref="ruleForm"
        :model="form"
        label-width="152px"
        :label-position="'left'"
      >
        <el-form-item label="输入成人座椅设备编号" prop="equ_no" class="form_item">
          <el-input
            v-model="form.equ_no"
            placeholder="请输入成人座椅设备编号"
            class="Input"
          ></el-input>
        </el-form-item>
        <el-form-item label="输入成人座椅设备ID" prop="equ_id" class="form_item">
          <el-input
            v-model="form.equ_id"
            placeholder="请确认成人座椅设备ID"
            class="Input"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- :loading="btnLoding" -->
      <el-button type="primary" plain medium @click="submitForm"
        >绑定</el-button
      >
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="dialogMessage"
      :show-close="false"
    >
      <span>{{ message }}</span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AdultSeat",
  data() {
    return {
      dialogVisible: false,
      btnLoding: false,
      // 弹窗消息提示
      message: undefined,
      // 表单参数
      form: { equ_no: undefined, equ_id: undefined },
      rules: {
        equ_no: [
          { required: true, trigger: "blur", message: "请输入成人座椅设备编号" },
        ],
        equ_id: [{ required: true, trigger: "blur", message: "请输入成人座椅设备ID" }],
      },
    };
  },

  methods: {
    submitForm() {
      this.btnLoding = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          try {
            axios({
              method: "get",
              url: "https://htapi.zxznzy.com/project/adult_bind_equid_equno",
              params: {
                ...this.form,
              },
            }).then((response) => {
              if (response.data.code == 1) {
                this.message = "成人座椅设备绑定成功";
              } else if (response.data.code == 0) {
                this.message =
                  response.data.message || "成人座椅设备绑定失败，请稍后再试";
              }
              this.btnLoding = false;
              this.dialogVisible = true;
              setTimeout(() => {
                this.dialogVisible = false;
                this.btnLoding = false;
                this.form.equ_no = "";
                this.form.equ_id = "";
              }, 2000);
            });
          } catch (error) {
            this.message = "成人座椅设备绑定失败，请稍后再试";
            this.btnLoding = false;
            this.dialogVisible = true;
            setTimeout(() => {
              this.dialogVisible = false;
              this.btnLoding = false;
              this.form.equ_no = "";
              this.form.equ_id = "";
            }, 2000);
            return;
          }
        } else {
          this.btnLoding = false;
          this.dialogVisible = true;
          this.message = "请检查输入的成人座椅设备编号和成人座椅设备ID是否正确";
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#AdultSeat {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: linear-gradient(45deg, #b5e4f9, #a7cadd);
  display: flex;
  justify-content: center;
  position: relative;
  height: 97vh;

  .form_item .el-form-item__content {
    margin-left: 0;
  }
  .card {
    width: 91vw;
    background-color: #fff;
    height: 45vh;
    border-radius: 1%;
    margin-top: 22vh;
    padding: 2vh 5px 0 5px;
    box-sizing: border-box;
  }
  .card-title {
    text-align: center !important;
    padding-right: 0 !important;
    font-size: 16px;
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
  
  .form_item .el-form-item__label {
   font-size: 13px !important;
  }
  
  .Input {
    width: 10rem;
    right: 1rem;
  }
  .Input .el-input__inner {
    width: 12rem;
  }
  .el-form-item {
    margin-bottom: 38px;
  }
  .el-form-item__error {
    margin-left: 20px;
  }
  .dialogMessage {
    margin-top: 47vh !important;
    width: 78% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
  }
}
</style>
